export default __webpack_public_path__ + "media/images/job-board-185d4eda902f5c1bd21db00c4b6a7ece.png";